<div class="modal-option-panel">
  <div class="modal-option-panel__header">
    <div class="modal-option-panel__title"><ng-content select="[panel-title]"></ng-content></div>
    <div class="modal-option-panel__side-actions"><ng-content select="[panel-side-start]"></ng-content></div>
    <div class="modal-option-panel__side"><ng-content select="[panel-side]"></ng-content></div>
    <div class="modal-option-panel__side-actions"><ng-content select="[panel-side-end]"></ng-content></div>
  </div>
  <ng-content></ng-content>
</div>
